import React from 'react';

const OptimismIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <g clip-path="url(#OP__a)">
            <path fill="#FE0420" d="M24 0H0v24h24z" />
            <path fill="#fff" fill-rule="evenodd" d="M4.859 15.378Q5.729 16 7.09 16q1.65 0 2.633-.744.985-.756 1.386-2.278.24-.933.412-1.922.057-.356.057-.59 0-.777-.4-1.333a2.4 2.4 0 0 0-1.1-.844Q9.381 7.999 8.5 8q-3.24 0-4.018 3.056a36 36 0 0 0-.424 1.922 4 4 0 0 0-.057.6q0 1.166.859 1.8m4.133-2.467c-.22.85-.824 1.405-1.74 1.405-.907 0-1.217-.613-1.054-1.405q.206-1.077.412-1.822c.237-.919.793-1.405 1.74-1.405.903 0 1.2.605 1.042 1.405a26 26 0 0 1-.4 1.822m3.469 3.009q.066.08.19.08h1.514a.33.33 0 0 0 .211-.08.33.33 0 0 0 .123-.206l.478-2.24h1.541c.973 0 1.734-.472 2.29-.891q.848-.63 1.125-1.943.067-.309.067-.594 0-.995-.757-1.52Q18.496 8 17.26 8h-2.963a.34.34 0 0 0-.211.08.33.33 0 0 0-.123.206l-1.537 7.428a.28.28 0 0 0 .034.206m5.412-5.303c-.139.612-.672 1.172-1.299 1.172h-1.28l.44-2.105h1.337c.455 0 .835.09.835.59q0 .15-.033.343" clip-rule="evenodd" />
        </g>
        <defs>
            <clipPath id="OP__a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>


);

export default OptimismIcon;
